import React from 'react';
import { Spinner, Container, Header, Title, Content, Text, Button, Icon, Left, Body, Right, List, ListItem, Accordion, Card, CardItem, View } from 'native-base';
import { poundMinus } from '../../components/globals';

const PrevTaxYearBox = props => {
	const canClick = props.year.submitted || props.year.submittable;
	return (
		<Card
			style={{
				borderColor: '#000',
				borderWidth: 1,
				borderTopLeftRadius: 10,
				borderTopRightRadius: 10,
				flex: null
			}}>
			<CardItem style={{ backgroundColor: '#EEE', borderTopLeftRadius: 10, borderTopRightRadius: 10, width: '100%' }}>
				<Left>
					<Icon style={{ color: '#888' }} name="calendar" />
					<Body>
						<Text style={{ color: canClick ? '#222' : '#666' }}>{props.year.text}</Text>
					</Body>
				</Left>
				<Right style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
					<View style={{ flexDirection: 'column' }}>
						<Text style={{ fontSize: 12, textAlign: 'right' }}>Status</Text>
						<Text style={{ textAlign: 'right' }}>{props.year.status}</Text>
					</View>
					<Icon
						style={{ alignSelf: 'flex-end', paddingLeft: 10, color: props.year.submitted ? 'green' : 'orange' }}
						name={
							props.year.status == 'submitted'
								? 'md-checkbox'
								: props.year.status == 'in progress'
								? 'ios-checkbox-outline'
								: props.year.status == 'waiting'
								? 'hourglass'
								: props.year.status == 'not submitted'
								? 'square-outline'
								: 'warning'
						}
					/>
				</Right>
			</CardItem>
			<CardItem button onPress={() => props.navigation.navigate('SaDetails', { year: props.year.taxyear })}>
				<View style={{ flexDirection: 'row', flex: 1, justifyContent: 'space-between' }}>
					<View style={{ flexDirection: 'column' }}>
						{!props.taxOnly && (
							<>
								<Text style={{ fontSize: 12 }}>Taxable Income</Text>
								<Text>{poundMinus(props.year.taxable, false, 0, true)}</Text>
							</>
						)}
					</View>
				</View>
				<Text style={{ textAlign: 'right' }}>{props.year.status == 'submitted' ? 'Open' : props.year.status == 'error' ? 'Try again' : props.year.status == 'waiting' ? 'Check' : 'Go'}</Text>
				<Icon name="arrow-forward" style={{ width: 20, color: '#777', marginLeft: 10 }} />
			</CardItem>
		</Card>
	);
};

export default PrevTaxYearBox;
